import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { checkJobAutomationAccess } from '../config/firestoreConfig'; // Import Firestore access check function
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth(); // Get the current user from AuthContext
  const [hasAccess, setHasAccess] = useState(null); // State to track if the user has access

  useEffect(() => {
    const verifyAccess = async () => {
      if (user) {
        // Check if the current user's email is in the allowed list
        const isAllowed = await checkJobAutomationAccess(user.email);
        setHasAccess(isAllowed); // Update state based on the access check
      } else {
        setHasAccess(false); // If no user is logged in, deny access
      }
    };

    verifyAccess(); // Verify access on component mount or when `user` changes
  }, [user]);

  if (hasAccess === null) {
    return <LoadingSpinner />;
  }

  // If the user has access, render the child components
  if (hasAccess) {
    return children;
  } else {
    // If no access, redirect to the login page
    return <Navigate to="/courses" />;
  }
};

export default ProtectedRoute;
